import React, { useEffect, useState } from "react";
import useClock from "./hooks/useClock";
import LiveFlipClock from "./LiveFlipClock";
import EAIMLogo from "../img/EAIM_b_logo.png";
import { EAIM_PURPLE, EAIM_PINK } from "./utils/constants";

const THEMES = {
  light: {
    gradientA: EAIM_PURPLE,
    gradientB: EAIM_PINK,
    text: "#fff",
    chipBg: "rgba(255,255,255,0.15)",
    badgeBorder: "6px solid rgba(255,255,255,0.35)",
  },
  dark: {
    gradientA: "#0E0F1A",
    gradientB: "#2A2E45",
    text: "#EDEDED",
    chipBg: "rgba(255,255,255,0.12)",
    badgeBorder: "6px solid rgba(255,255,255,0.25)",
  },
};

// const DEFAULT_ANNOUNCEMENT =
//   "📢 Welcome to EAIM — Dear Students, our campus has officially moved to a brand-new location! 🎉✨ Get ready for a fresh start in a vibrant new space that’s designed to inspire learning and growth.";

// const DEFAULT_DEPT = "GENERAL";

const HeaderBar = ({
  backgroundImg,
  announcement,
  marqueeSpeed = 18,
  onThemeChange,
  onViewModeChange,
}) => {
  const { dateStr } = useClock();

  const [theme, setTheme] = useState(() => {
    return localStorage.getItem("eaimTheme") || "dark";
  });
  const toggleTheme = () => {
    const next = theme === "light" ? "dark" : "light";
    setTheme(next);
    window.dispatchEvent(new CustomEvent("eaim-theme", { detail: next }));
  };
  useEffect(() => {
    localStorage.setItem("eaimTheme", theme);
    document.documentElement.setAttribute("data-theme", theme);
    onThemeChange?.(theme);
    window.dispatchEvent(new CustomEvent("eaim-theme", { detail: theme }));
  }, [theme, onThemeChange]);

  const [viewMode, setViewMode] = useState(() => {
    return localStorage.getItem("eaimViewMode") === "list" ? "list" : "grid";
  });
  const toggleViewMode = () => {
    const next = viewMode === "grid" ? "list" : "grid";
    setViewMode(next);
  };
  useEffect(() => {
    localStorage.setItem("eaimViewMode", viewMode);
    onViewModeChange?.(viewMode);
    window.dispatchEvent(
      new CustomEvent("eaim-view-mode", { detail: viewMode })
    );
  }, [viewMode, onViewModeChange]);

  const t = THEMES[theme];

  // const [dbAnns, setDbAnns] = useState(null);
  
  // useEffect(() => {
  //   let canceled = false;
  //   (async () => {
  //     try {
  //       const res = await fetch(
  //         `${process.env.REACT_APP_API}/listActiveAnnouncements`,
  //         {
  //           headers: { Accept: "application/json" },
  //           cache: "no-store",
  //         }
  //       );
  //       const ct = res.headers.get("content-type") || "";
  //       const text = await res.text();
  //       const json = ct.includes("application/json") ? JSON.parse(text) : null;
  //       if (!canceled && res.ok && json?.success) {
  //         const items = Array.isArray(json.data) ? json.data : [];
  //         const mapped = items
  //           .map((i) => ({
  //             text: i.announcement,
  //             dept: i.dept || DEFAULT_DEPT,
  //           }))
  //           .filter((x) => x.text);
  //         setDbAnns(mapped);
  //       } else if (!canceled) {
  //         setDbAnns([]);
  //       }
  //     } catch {
  //       if (!canceled) setDbAnns([]);
  //     }
  //   })();
  //   return () => {
  //     canceled = true;
  //   };
  // }, []);

  // const effectiveEntries = useMemo(() => {
  //   if (Array.isArray(dbAnns) && dbAnns.length) return dbAnns;
  //   if (Array.isArray(announcement) && announcement.length) {
  //     return announcement
  //       .filter(Boolean)
  //       .map((t) => ({ text: t, dept: DEFAULT_DEPT }));
  //   }
  //   if (typeof announcement === "string" && announcement.trim()) {
  //     return [{ text: announcement.trim(), dept: DEFAULT_DEPT }];
  //   }
  //   return [{ text: DEFAULT_ANNOUNCEMENT, dept: DEFAULT_DEPT }];
  // }, [dbAnns, announcement]);

  return (
    <div style={{ position: "relative" }}>
      <style>{`
  @keyframes eaim-marquee-left { 0%{transform:translateX(0)} 100%{transform:translateX(-50%)} }
  .eaim-marquee-track { display:inline-block; white-space:nowrap; will-change:transform; animation: eaim-marquee-left ${marqueeSpeed}s linear infinite; }
  .eaim-marquee:hover .eaim-marquee-track { animation-play-state: paused; }

  .eaim-ann-item { display:inline-flex; align-items:center; gap:10px; margin-right:48px; }
  .eaim-pill {
    display:inline-flex; align-items:center; justify-content:center;
    padding:4px 10px; border-radius:999px;
    background: rgba(255,255,255,0.18);
    border:1px solid rgba(255,255,255,0.35);
    color:#fff; font-weight:800; letter-spacing:.4px; font-size:12px; text-transform:uppercase;
    box-shadow:0 2px 6px rgba(0,0,0,.18);
  }
  .eaim-ann-text { font-weight:600; letter-spacing:.2px; font-size:14px; padding-bottom:1px; }

  .eaim-toggle, .eaim-iconbtn {
    display:inline-flex; align-items:center; gap:8px; padding:6px 10px; border-radius:999px;
    border:1px solid rgba(255,255,255,0.3); background: rgba(0,0,0,0.15); color:#fff; cursor:pointer; user-select:none; transition: transform .08s ease, background .15s ease;
  }
  .eaim-toggle:active, .eaim-iconbtn:active { transform: scale(0.98); }
  .eaim-toggle__knob { width:28px; height:28px; border-radius:50%; display:flex; align-items:center; justify-content:center; background: rgba(255,255,255,0.22); }
  .eaim-toggle__label { font-weight:700; letter-spacing:.3px; font-size:12px; }

  .eaim-iconbtn[aria-pressed="true"] { background: rgba(255,255,255,0.22); }

  .eaim-chip {
    display:flex; align-items:center; gap:8px; background: ${t.chipBg};
    padding: 8px 12px; border-radius: 10px; font-weight:600; backdrop-filter: blur(2px);
  }
`}</style>
     

      <div
        style={{
          position: "relative",
          padding: "18px 24px 24px",
          background: "#e0dedeff", // backgroundImg
            // ? `url(${backgroundImg}) center/cover no-repeat`
            // : `linear-gradient(135deg, ${t.gradientA} 0%, ${t.gradientB} 70%)`,
          color: t.text,
          boxShadow: "inset 0 -6px 0 rgba(176, 18, 138, 0.65)",
          overflow: "visible",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 12 ,paddingLeft:"40px"}}>
          <img
            src={EAIMLogo}
            alt="EAIM Logo"
            style={{ height: 80, objectFit: "contain" }}
          />
        </div>

        <div
          style={{
            position: "absolute",
            top: 12,
            right: 24,
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-end",
            gap: 10,
            zIndex: 2,
            paddingRight:"50px"
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <button
              type="button"
              className="eaim-toggle"
              aria-pressed={theme === "dark"}
              aria-label="Toggle theme"
              onClick={toggleTheme}
              title={`Switch to ${theme === "light" ? "Dark" : "Light"} Theme`}
            >
              <div className="eaim-toggle__knob" aria-hidden="true">
                {theme === "light" ? "🌞" : "🌙"}
              </div>
            </button>

            <div className="eaim-chip" style={{ color: "#000" }}>
              <span role="img" aria-label="calendar">
                📅
              </span>
              {dateStr}
            </div>
          </div>

          <div
            style={{
              transform: "translateY(4px)",
              display: "flex",
              alignItems: "center",
              gap: 10,
            }}
          >
            <button
              type="button"
              className="eaim-iconbtn"
              style={{ marginTop: "60px" }}
              aria-pressed={viewMode === "list"}
              aria-label={`Switch to ${
                viewMode === "grid" ? "List" : "Grid"
              } view`}
              onClick={toggleViewMode}
              title={
                viewMode === "grid"
                  ? "Switch to List view"
                  : "Switch to Grid view"
              }
            >
              {viewMode === "grid" ? (
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <rect x="4" y="4" width="7" height="7" rx="1"></rect>
                  <rect x="13" y="4" width="7" height="7" rx="1"></rect>
                  <rect x="4" y="13" width="7" height="7" rx="1"></rect>
                  <rect x="13" y="13" width="7" height="7" rx="1"></rect>
                </svg>
              ) : (
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <rect x="4" y="5" width="16" height="2" rx="1"></rect>
                  <rect x="4" y="11" width="16" height="2" rx="1"></rect>
                  <rect x="4" y="17" width="16" height="2" rx="1"></rect>
                </svg>
              )}
            </button>

            <LiveFlipClock height={56} width={40} fontSize={40} />
          </div>
        </div>

        <div style={{ display: "flex", justifyContent: "center" }}>
          <div
            style={{
              background: "#B31E8D",
              fontSize: 30,
              padding: "12px 28px",
              color: "#fff",
              borderRadius: "40px",
              border: t.badgeBorder,
              position: "absolute",
              bottom: -36,
              boxShadow: `
                0 8px 12px rgba(0,0,0,0.3),
                0 4px 6px rgba(0,0,0,0.2),
                inset 0 4px 6px rgba(255,255,255,0.3),
                inset 0 -4px 6px rgba(0,0,0,0.25)
              `,
            }}
          >
            Classes In Session
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderBar;
